export default "__VITE_ASSET__7xna871x__"